module.exports = __webpack_public_path__ + "assets/82cd4705ef0fe79f67ba54a8a8aa5b39.png";